import React from "react";
import moment from "moment";
import SmallCard from "../card/small-card/small-card.js";

const LastOrderCard = ({
  loading = false,
  daysSinceLastOrder,
  lastOrderDate,
}) => {
  const hasOrder =
    daysSinceLastOrder !== null &&
    daysSinceLastOrder !== undefined &&
    lastOrderDate;
  const displayDays = hasOrder ? daysSinceLastOrder : "-";
  const displayDate = hasOrder
    ? moment(lastOrderDate).format("MM-DD-YYYY")
    : "No orders";

  return (
    <SmallCard
      loading={loading}
      title="Days since last order"
      number={displayDays}
      date={displayDate}
    />
  );
};

export default LastOrderCard;
